import { Button, Modal, Table } from 'antd';
import moment from 'moment';
import 'moment/locale/ko';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import uuid from 'react-uuid';
import { reactLocalStorage } from 'reactjs-localstorage';
import { bindActionCreators } from 'redux';
import { setBranchInfo } from '../actions/branchAction';
import { setDeposit } from '../actions/depositAction';
import { login, logout, setConsentDocId } from '../actions/loginAction';
import {
  updateBasicPickupTime,
  updateBasicPickupTimeAndDelay,
  updateBranchDelayTime,
} from '../actions/pickupTimeAction';
import {
  addOrderInfo,
  addPosOrder,
  addWaitingOrder,
  removeOldPosOrder,
  removeOldWaitingOrder,
  removeOrderInfoAll,
  removePosOrder,
  removePosOrderAll,
  removePosOrderByOrderAwaitId,
  removePosOrderByOrderCode,
  removeWaitingOrder,
  removeWaitingOrderAll,
  removeWaitingOrderByOrderAwaitId,
  removeWaitingOrderByOrderCode,
  setMultiPosSetting,
  setVolumeSetting,
  updatePosOrder,
  updateWaitingOrder,
} from '../actions/posAction';
import {
  calcShippingDataAsync,
  createOrderAsync,
  getCidNumAsync,
  getEventBannerList,
  createOrderInfoAtCloudFlareWorker,
  getOrderInfoListFromCloudFlareWorker,
  getOrderInfoDetailFromCloudFlareWorker,
  getPosOrderDataAsync,
  setConsentDocIdAsync,
  getRouletteInfo,
  getRouletteInfoFromAllServer,
  updatePosDeliveryStatusAsync,
  deleteOrderAwaitAsync,
  deleteOrderAwaitAtCloudFlareWorker,
  getOrderAwaitByBranchIdxFrIdxAtCloudFlareWorker,
} from '../api/api';
import {
  httpExec,
  httpGet,
  httpPost,
  httpUrl,
  imageUrl,
} from '../api/httpClient';
import Const from '../const';
import {
  getNotifyPosOrderPort,
  getNotifyPosOrderRelationAppPort,
  getPosOrderAllowDuplicates,
  getPosOrderRelationAppAllowDuplicates,
  getUseNotifyCid,
  getUseNotifyOrderEtc,
  getUseNotifyPosOrder,
  getUseNotifyPosOrderRelationApp,
  getPreviousNotifyCompleteOrders,
  getPreviousNotifyOrders,
  generateOrderNotification,
  executeCompleteOrderNotification,
  executeOrderNotification,
  setPreviousNotifyCompleteOrders,
  setPreviousNotifyOrders,
  getUseAutoConfirmOrder,
  getAutoConfirmPickupTime,
} from '../lib/module';
import {
  checkDepositCharge,
  getFrStatusString,
  orderStatusCode,
  pickupTimeValue,
  modalStyle,
  modalErrorStyle,
} from '../lib/util/codeUtil';
import {
  addPendingOrder,
  isExistsPendingOrder, isSameOrder,
} from '../lib/util/orderUtil';
import { checkBetweenTime, formatHM } from '../lib/util/dateUtil';
import { comma } from '../lib/util/numberUtil';
import Chatting from '../pages/chat/Chatting';
import ChargeModal from './modal/ChargeModal';
import ControlChatModal from './modal/ControlChatModal';
import EFormsignModal from './modal/EFormsignModal';
import PaystoryChargeModal from './modal/PaystoryChargeModal';
import PosOrderModal from './modal/PosOrderModal';
import Popup from '../pages/popup/Popup';
import YWebSocket from "./yogiyo/YWebSocket";
import image from '../res/image';
import { eFormsignControl } from '../lib/eFormSignHelper';

const wsReadyState = {
  CONNECTING: 0,
  OPEN: 1,
  CLOSING: 2,
  CLOSED: 3,
};

const getWSReadyStateStr = (state) => {
  return state === 0
    ? 'CONNECTING'
    : state === 1
    ? 'OPEN'
    : state === 2
    ? 'CLOSING'
    : state === 3
    ? 'CLOSED'
    : '';
};

const titleofConsent = '개인정보 제공 동의';
const showErrorMessageBox = (code) => {
  Modal.error({
    title: `${titleofConsent} 처리 오류`,
    content: (
      <div>오류가 발생하였습니다. 지점 관리자에게 문의하세요. Code: {code}</div>
    ),
    ...modalErrorStyle,
    onOk() {},
  });
};

const isBaeminOrderCode = (data) => {
  return data.bmOrderCode && data.bmOrderCode != '';
};

const setPosDeliveryStatus = (data, cancel, userIdx, userToken) => {
  if (!getUseNotifyPosOrder()) {
    return;
  }
  if (!isBaeminOrderCode(data)) {
    return;
  }
  let deliveryStatus = -1;
  switch (data.status) {
    case orderStatusCode.assign:
      deliveryStatus = 0;
      break;
    case orderStatusCode.pickup:
      deliveryStatus = 1;
      break;
  }
  if (deliveryStatus >= 0) {
    updatePosDeliveryStatusAsync(getNotifyPosOrderPort(), {
      userIdx,
      userToken,
      orderNo: data.bmOrderCode,
      deliveryStatus,
      riderKey: data.riderKey,
      riderName: '',
    });
  }
};
const setPosDeliveryStatusComplete = (data, userIdx, userToken) => {
  if (!getUseNotifyPosOrder()) {
    return;
  }
  if (!isBaeminOrderCode(data)) {
    return;
  }
  updatePosDeliveryStatusAsync(getNotifyPosOrderPort(), {
    userIdx,
    userToken,
    orderNo: data.bmOrderCode,
    deliveryStatus: 2,
  });
};

const truncate = (str, n) => {
  return str?.length > n ? str.substr(0, n) + "..." : str;
};

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addrBranch: { quickMenu: true },
      currentTimeString: '',
      pickupTimeString: '',
      deliveryEnabled: true,
      delayPickupTime: 0,
      frBasicPickupTime: 0,

      posOrderModalOpen: false,
      posOrder: {},
      cidList: [],
      cidPopup: false,

      isPosPolling: false,
      isSubPosPolling: false,

      openSlideMenu: 0,

      noticeVisible: false,
      noticeList: [],
      selectedNotice: 0,
      mainNotice: null,
      pagination: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
      noticePagination: {
        pageSize: 10,
        current: 1,
        total: 0,
      },

      chatModalOpen: false,

      controlChatModalOpen: false,

      eFormsignModalOpen: false,

      surchargeSum: 0,
      branchTel: '',
      skinPopupList: [],
      popupVisible: true,
      isMobile: window.innerWidth < Const.maxMobileWidth,

      eventRankList: [],
    };
    this.formRef = React.createRef();
    this.url = `${Const.wsProtocol}://${Const.wsHost}:${Const.wsPort}${Const.wsPath}`;
    this.ws = null;
    this.noticeForNew = null;
    this.cidIdx = 5;
    this.pollingOrderAwaitList = [];
    this.orderAwaitIntervalLock = false;
  }

  async componentDidMount() {
    global.cidNum = '';
    const self = this;
    this.initializeUserInfo();

    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    console.log(this.state.isMobile);
    // const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    // this.setState({ isMobile });
    // console.log(`isMobile: ${isMobile}`);

    // 주문정보 조회 방식 변경으로 redux 세팅 제거
    // await this.loadOderInfo();

    this.getNoticeList(true, (notices) => {
      if (this.noticeForNew == null) {
        this.noticeForNew = reactLocalStorage.getObject(
          Const.appName + '#noticeForNew'
        );
        // console.log("typeof this.noticeForNew");
        // console.log(typeof this.noticeForNew);
      }
      if (this.noticeForNew != null && this.noticeForNew.length > 0) {
        notices.forEach((value) => {
          if (this.noticeForNew.findIndex((x) => x.idx == value.idx) < 0) {
            this.messageAlert();
            this.setState({
              noticeVisible: true,
              selectedNotice: value.idx,
            });
          }
        });
      }

      this.noticeForNew = notices;
      reactLocalStorage.setObject(Const.appName + '#noticeForNew', notices);
    });
    this.noticeTimeInterval = setInterval(() => {
      if (!this.state.noticeVisible) {
        //신규공지가 있을때만 팝업
        this.setState(
          {
            pagination: {
              pageSize: 10,
              current: 1,
            },
          },
          () =>
            this.getNoticeList(true, (notices) => {
              if (this.noticeForNew == null) {
                this.noticeForNew = reactLocalStorage.getObject(
                  Const.appName + '#noticeForNew'
                );
              }
              if (this.noticeForNew != null) {
                notices.forEach((value) => {
                  if (
                    this.noticeForNew.findIndex((x) => x.idx == value.idx) < 0
                  ) {
                    this.messageAlert();
                    this.setState({
                      noticeVisible: true,
                      selectedNotice: value.idx,
                    });
                  }
                });
              }

              this.noticeForNew = notices;
              reactLocalStorage.setObject(
                Const.appName + '#noticeForNew',
                notices
              );
            })
        );
      }
    }, Const.noticeInterval);

    this.updateBmCompleteOrderInterval = setInterval(() => {
      this.updateBmCompleteOrder();
    }, Const.posOrderInterval);

    this.updateBmOrderInterval = setInterval(() => {
      this.updateBmOrder();
    }, Const.posOrderInterval + 1600);

    this.renewDeposit(true);
    this.depositTimeInterval = setInterval(() => {
      if (!this.state.chargeModalOpen) this.renewDeposit(true);
    }, Const.depositInterval);

    this.systemStatusInterval = setInterval(() => {
      this.systemStatus();
    }, Const.systemStatusTimeInterval);

    /* 1923 일감 관련
    행걸리는 이슈가 있어서 수석처리
     this.franchiseLocalStorage();
    */
    // this.localStorageInterval = setInterval(
    //   () => this.franchiseLocalStorage(),
    //   Const.localStorageInterval
    // );

    this.getBranchDelayInfoAndSet();

    this.renewDeliveryDataInterval = setInterval(() => {
      this.getBranchDelayInfoAndSet();
    }, 30000);

    //배달의 민족 주문연동 time interval
    this.posOrderTimeInterval = setInterval(() => {
      const enable = getUseNotifyPosOrder();
      if (enable) {
        getPosOrderDataAsync(
          getNotifyPosOrderPort(),
          getPosOrderAllowDuplicates(),
          this.props.loginReducer.loginInfo.branchIdx,
          this.props.loginReducer.loginInfo.idx,
          !this.props.loginReducer.loginInfo.token
            ? ''
            : this.props.loginReducer.loginInfo.token,
          this.props.posReducer.waitingOrders,
          this.props.addWaitingOrder
        ).then((res) => {
          console.log("------------------------------");
          console.log(res.result);
          res.result === 'SUCCESS' ? this.setState({ isPosPolling: true }): this.setState({ isPosPolling: false });
        })
        .catch((err) => {
        });
      }
    }, Const.posOrderInterval);

    // POS order relation time interval
    this.posOrderRelationAppTimeInterval = setInterval(() => {
      const posenable = getUseNotifyPosOrderRelationApp();
      if (posenable) {
        getPosOrderDataAsync(
          getNotifyPosOrderRelationAppPort(),
          getPosOrderRelationAppAllowDuplicates(),
          this.props.loginReducer.loginInfo.branchIdx,
          this.props.loginReducer.loginInfo.idx,
          !this.props.loginReducer.loginInfo.token
            ? ''
            : this.props.loginReducer.loginInfo.token,
          this.props.posReducer.waitingOrders,
          this.props.addWaitingOrder
        ).then((res) => {
          res.result === 'SUCCESS' ? this.setState({ isSubPosPolling: true }) : this.setState({ isSubPosPolling: false });
        })
        .catch((err) => {
        });
      }
    }, Const.posOrderRelationAppInterval);

    //CID Relation time interval
    this.cidTimeInterval = setInterval(() => {
      const enable = getUseNotifyCid();
      if (enable) {
        getCidNumAsync().then((cidNum) => {
          if (cidNum && cidNum.length > 0 && global.cidNum != cidNum) {
            global.cidNum = cidNum;
            this.state.cidList.push({
              idx: this.cidIdx++,
              cidNum,
              createDate: moment().format('HH:mm:ss'),
            });
            self.setState({
              cidList: this.state.cidList,
              cidPopup: true,
            });
          } else if (!cidNum || cidNum.length == 0) global.cidNum = '';
        });
      }
    }, Const.cidRelationAppInterval);

    this.getAddrBranchesAsync();
    this.getAddrBranchesTimeInterval = setInterval(
      this.getAddrBranchesAsync,
      Const.addrBranchesInterval
    );

    this.getAddrDeliveryAsync();
    this.getAddrBranchesTimeInterval = setInterval(
      this.getAddrDeliveryAsync,
      Const.addrBranchesInterval
    );

    this.getSurchargeAsync();
    this.getSurchargeTimeInterval = setInterval(
      this.getSurchargeAsync,
      Const.surchargeInterval
    );

    this.updateTime();
    this.updateTimeInterval = setInterval(() => {
      this.updateTime();
    }, 180000);

    this.frUpdateTime();
    this.frUpdateTimeInterval = setInterval(() => {
      this.frUpdateTime();
    }, 180000);

    this.getOrderAwaitList();
    this.orderAwaitTimeInterval = setInterval(async () => {
      //진행중일때 block
      if (this.orderAwaitIntervalLock) return;
      this.orderAwaitIntervalLock = true;
      try {
        await this.getOrderAwaitList();
      } catch(e) {}
      this.orderAwaitIntervalLock = false;

    }, Const.orderAwaitListPollingTimeMS);

    // 10분에 한번씩 this.pollingOrderAwaitList 초기화
    this.globalOrderAwaitResetInterval = setInterval(() => {
      this.pollingOrderAwaitList = [];
    }, 600000);
    /*await this.getFrIPInfo();
    this.getFrIPInfoInterval = setInterval(() => {
      this.getFrIPInfo();
    }, Const.getFrIPInfoInterval);*/

    this.getSkinPopupList();

    const notifyChat = reactLocalStorage.getObject(
      Const.appName + '#notifyChat'
    );
    if (typeof notifyChat === 'boolean') {
      this.setState({ notifyChat });
    }

    global.registerBridgeActionEventHandler(
      'InfOrder',
      this.handleBridgeAction
    );

    this.initializeVolumeSetting();
    this.initializeMultiPosSetting();

    this.props.removeOldPosOrder();

    this.props.removeOldWaitingOrder();

    if (
      this.props.loginReducer.loginInfo.frOrderAgency &&
      this.props.loginReducer.loginInfo.frOrderAgency.filter(
        (foa) => foa.posCode === 'psCode'
      ).length > 0
    ) {
      const psBaeminSetting = reactLocalStorage.getObject(
        Const.appName + '#psBaeminSetting'
      );
      if (typeof psBaeminSetting === 'boolean') {
        global.psBaeminSetting = psBaeminSetting;
      }
    }

    // 새로고침 하면 기존에 localstorage에 들어간 rank가 노출시간 완료 안되도 없어짐
    // 이를 위해 새로고침 시 localstorage에서 노출시간 완료 안 된 rank 추가
    this.eventRankListOnRefresh();

    // 1분에 한번 룰렛 rank정보 조회
    this.handleEventRankList();
    this.handleEventRankListInterval = setInterval(() => this.handleEventRankList(), 60000);

    // 1분에 한번 노출 시간 지난 rank 제거
    this.clearOldRankListInterval = setInterval(() => this.clearOldRankList(), 60000);

    //2024.06.11 정보제공동의 팝업 일단 막음
    // eFormsignControl.initialize();
    // this.eFormsignControlTimeInterval = setInterval(() => {
    //   if (
    //     !this.props.loginReducer.loginInfo.consentDocId &&
    //     !this.state.eFormsignModalOpen &&
    //     eFormsignControl.getIsinitialized()
    //   ) {
    //     this.setState({ eFormsignModalOpen: true });
    //     clearInterval(this.eFormsignControlTimeInterval);
    //   }
    // }, 1000);
  }

  // window 크기 조절 check
  handleResize = () => {
  const isMobile = window.innerWidth < Const.maxMobileWidth;
    if (isMobile !== this.state.isMobile) {
    this.setState({ isMobile });
    }
  };
  eventRankListOnRefresh = () => {
    let prevRankList = reactLocalStorage.getObject(`${Const.appName}#septemberRankList`);
    if (!Array.isArray(prevRankList)) return;

    const notDoneRankList = prevRankList.filter((rank) => {
      const now = new moment();
      const timestamp = new moment(rank.updateTime);

      const diff = now.diff(timestamp, 'minutes');
      if (diff <= 5) return true;
      else return false;
    })

    this.setState({
      eventRankList: this.state.eventRankList.concat(notDoneRankList),
    })
  }

  handleEventRankList = async () => {
    const bannerRes = await getEventBannerList();
    if (bannerRes === null) return;

    const eventList = bannerRes?.data?.eventList;
    if (eventList === null || eventList === undefined || !Array.isArray(eventList) || eventList.length < 1) return;
    const event = eventList[0];
    const eventIdx = event?.idx;
    if (eventIdx === null || eventIdx === undefined) return;

    const rouletteRes = await getRouletteInfoFromAllServer(eventIdx);
    if (rouletteRes === null) return;

    let rankList = rouletteRes?.data?.rankList;
    if (rankList === null || rankList === undefined || !Array.isArray(rankList) || rankList.length < 1) return;

    let prevRankList = reactLocalStorage.getObject(`${Const.appName}#septemberRankList`);
    console.log('prevRankList', prevRankList, Array.isArray(prevRankList));
    if (!Array.isArray(prevRankList)) prevRankList = [];

    rankList = rankList.filter(rank => rank.rank < 4);
    const newRankList = rankList.filter(rank =>
        prevRankList.findIndex(
          (prev) => {
            return (prev.eventIdx === rank.eventIdx &&
            prev.rank === rank.rank &&
            prev.userIdx === rank.userIdx)
          }
        ) < 0
    );

    let newRankListWithTimestamp = [];
    newRankList.forEach(rank => {
      const now = new moment();
      newRankListWithTimestamp.push({
        ...rank,
        updateTime:now,
      });
    });

    this.setState({
      eventRankList: this.state.eventRankList.concat(newRankListWithTimestamp),
    }, () => {
        reactLocalStorage.setObject(
          `${Const.appName}#septemberRankList`,
          prevRankList.concat(newRankListWithTimestamp)
        );
    });
  }

  clearOldRankList = () => {
    this.setState({
      eventRankList: this.state.eventRankList.filter(rank => {
        const now = new moment();
        const timestamp = new moment(rank.updateTime);
        const diff = now.diff(timestamp, 'minutes');
        // 기획서 상으로는 3번 노출로 되어 있는데 노출 횟수를 정확히 셀수 없기 때문에
        // 5분 노출로 대체
        if (diff > 5) return false;
        else return true;
      })
    })
  }

  getBranchDelayInfoAndSet() {
    Promise.all([
      this.getBasicPickupTimesAsync(),
      this.renewDeliveryData(),
    ]).then((values) => {
      const basicPickupTime = values[0];
      const deliveryData = values[1];

      if (basicPickupTime == null || deliveryData == null) {
        return;
      }

      reactLocalStorage.setObject(
        Const.appName + '#deliverydata',
        deliveryData
      );
      reactLocalStorage.setObject(
        Const.appName + '#deliveryStatShow',
        deliveryData.deliveryStatShow
      );
      reactLocalStorage.setObject(
        Const.appName + '#branchTel',
        deliveryData.tel
      );

      this.setState({
        frBasicPickupTime: basicPickupTime,
        deliveryEnabled: deliveryData.deliveryEnabled,
        branchTel: deliveryData.tel,
        delayPickupTime: deliveryData.delayPickupTime,
      });

      if (
        (basicPickupTime !==
          this.props.pickupTimeReducer.pickupTimeInfo.basicPickupTime ||
          deliveryData.delayPickupTime !==
            this.props.pickupTimeReducer.pickupTimeInfo.delayPickupTime ||
          deliveryData.deliveryEnabled !==
            this.props.pickupTimeReducer.pickupTimeInfo.deliveryEnabled ||
          deliveryData.addrUpdateEnabled !==
            this.props.pickupTimeReducer.pickupTimeInfo.addrUpdateEnabled) &&
        !this.props.pickupTimeReducer.pickupTimeInfo.manualPickupTimeSetup
      ) {
        this.props.updateBasicPickupTimeAndDelay({
          basicPickupTime: basicPickupTime,
          pickupDelay: deliveryData.delayPickupTime,
          deliveryEnabled: deliveryData.deliveryEnabled,
          addrUpdateEnabled: deliveryData.addrUpdateEnabled,
          updateFromServer: true,
        });
      }
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    if (this.noticeTimeInterval) clearInterval(this.noticeTimeInterval);
    if (this.depositTimeInterval) clearInterval(this.depositTimeInterval);
    if (this.updateBmCompleteOrderInterval)
      clearInterval(this.updateBmCompleteOrderInterval);
      if (this.updateBmOrderInterval)
        clearInterval(this.updateBmOrderInterval);

    if (this.systemStatusInterval) clearInterval(this.systemStatusInterval);
    // if (this.deliveryDataInterval) clearInterval(this.deliveryDataInterval);
    if (this.notifyOrderTimeInterval)
      clearInterval(this.notifyOrderTimeInterval);
    if (this.posOrderTimeInterval) clearInterval(this.posOrderTimeInterval);
    if (this.posOrderRelationAppTimeInterval)
      clearInterval(this.posOrderRelationAppTimeInterval);
    if (this.renewDeliveryDataInterval)
      clearInterval(this.renewDeliveryDataInterval);
    if (this.cidTimeInterval) clearInterval(this.cidTimeInterval);
    if (this.updateTimeInterval) clearInterval(this.updateTimeInterval);
    if (this.frUpdateTimeInterval) clearInterval(this.frUpdateTimeInterval);
    if (this.getAddrBranchesTimeInterval)
      clearInterval(this.getAddrBranchesTimeInterval);
    if (this.getSurchargeTimeInterval)
      clearInterval(this.getSurchargeTimeInterval);
    if (this.updateBasicPickupTime) clearInterval(this.updateBasicPickupTime);
    if (this.orderAwaitTimeInterval) clearInterval(this.orderAwaitTimeInterval);
    if (this.globalOrderAwaitResetInterval) clearInterval(this.globalOrderAwaitResetInterval);
    if (this.localStorageInterval) clearInterval(this.localStorageInterval);
    /*if (this.getFrIPInfoInterval) clearInterval(this.getFrIPInfoInterval);*/
    /*if (this.skinPopupTimeInterval) clearInterval(this.skinPopupTimeInterval);*/
    if (this.clearOldRankListInterval) clearInterval(this.clearOldRankListInterval);
    if (this.handleEventRankListInterval) clearInterval(this.handleEventRankListInterval);
    if (this.eFormsignControlTimeInterval) clearInterval(this.eFormsignControlTimeInterval);

    global.unregisterBridgeActionEventHandler('InfOrder');
  }

  initializeUserInfo = () => {
    const userInfo = reactLocalStorage.getObject(Const.appName + '#userinfo');
    const deposit = reactLocalStorage.getObject(Const.appName + '#deposit');
    if (!userInfo || !userInfo.id) this.props.history.push('/');
    else {
      this.props.login(userInfo);
      this.props.setDeposit(deposit);
    }
  };
  logout = () => {
    httpPost(httpUrl.logout, [], {})
      .then(() => {
        this.props.onLogout();
        global.location.href = '/';
      })
      .catch((e) => {
        global.location.href = '/';
      });
  };

  getNoticeList = (hideLoading, callback) => {
    const { pageSize, current } = this.state.noticePagination;
    httpGet(httpUrl.noticeList, [pageSize, current], {}, hideLoading).then(
      (res) => {
        this.setState(
          {
            noticeList: res.data.notices,
            noticePagination: {
              ...this.state.noticePagination,
              total: res.data.totalCount,
            },
          },
          () => {
            if (callback instanceof Function) callback(res.data.notices);
          }
        );
        if (res.data.notices.length > 0 && res.data.currentPage === 1) {
          this.setState({ mainNotice: res.data.notices[0] });
        }
      }
    );
  };

  systemStatus = () => {
    httpGet(httpUrl.systemStatus, [], {}).then((res) => {
      const systemVersion = res.data.filter(
        (item) => item.service === 'FRANCHISE'
      );
      if (systemVersion[0].status > Const.clientMinorVersion)
        Modal.info({
          title: '버전 업데이트 정보',
          content:
            '신규 업데이트가 있습니다. 새로고침(F5)을 해주세요. (해당 팝업이 계속 뜰 경우 브라우저 캐시를 삭제하시기 바랍니다.)',
          ...modalStyle,
          onOk() {
            window.location.reload(true);
          },
        });
    });
  };

  renewDeposit = (hideLoading) => {
    const useEtcVoiceGuidance = getUseNotifyOrderEtc();

    this.getDepositAsync(hideLoading).then((deposit) => {
      if (deposit > 0) {
        this.props.setDeposit(deposit);

        if (!this.props.loginReducer.loginInfo.duesAutoChargeEnabled) {
          const key = checkDepositCharge(deposit);
          if (key >= 0 && key !== this.rechargeKey) {
            this.rechargeKey = key;

            const text =
              comma(deposit) +
              '원으로 예치금 잔액이 부족합니다 예치금을 충전하세요.';
            Modal.info({
              title: '예치금 충전 알림',
              content: <div>{text}</div>,
              ...modalStyle,
              onOk() {},
            });
            if (useEtcVoiceGuidance) {
              let audio = new Audio('11.wav');
              audio.volume = this.props.posReducer.volume;
              audio.crossOrigin = 'anonymous';
              audio.play();
            }
          }
        }
      }
    });
  };
  renewDeliveryData = async () => {
    /*
    함수내에서 사용되지 않는 값, 일단 주석 처리후
    추후 삭제 필요
    const prevDeliveryData = await reactLocalStorage.getObject(
      Const.appName + '#deliverydata'
    );
    const useEtcVoiceGuidance = getUseNotifyOrderEtc();
     */

    const res = await this.getDeliveryDataAsync(true);
    if (res.result === 'SUCCESS') {
      this.props.setBranchInfo(res.data);
      return res.data;
    } else {
      return null;
    }
  };
  resulteFormsignInfo = async (frIdx, branchIdx, documentId, code) => {
    // 문서 작성 실패
    if (code != '-1') {
      console.error(code);
      showErrorMessageBox(code);
      return;
    }

    console.log(`documentId: ${documentId}`);

    try {
      const res = await setConsentDocIdAsync(frIdx, branchIdx, documentId);
      console.log('------------------------------');
      console.log(res);
      if (res == 'SUCCESS') {
        this.props.setConsentDocId(documentId);
        Modal.info({
          title: `${titleofConsent}`,
          content: <div>{titleofConsent}가 완료 되었습니다. 감사합니다.</div>,
          ...modalStyle,
          onOk() {},
        });
      }
    } catch (err) {
      console.error(err);
      showErrorMessageBox(-99);
    }
  };

  // loadOderInfo = async () => {
  //   // 주문 정보
  //   try {
  //     const orderInfos = await getOrderInfoListFromCloudFlareWorker();
  //     if (orderInfos && Array.isArray(orderInfos)) {
  //       this.props.removeOrderInfoAll(true);
  //       orderInfos.forEach((orderInfo) => {
  //         this.props.addOrderInfo(orderInfo, true);
  //       });
  //     }
  //   } catch (e) {
  //     console.error("Error while loading orderInfo", e);
  //   }
  // };

  updateBmCompleteOrder = async () => {
    const completeOrders = await this.getOrderCompleteListAsync(true);
    const completePrevious = getPreviousNotifyCompleteOrders();
    const completeLatest = generateOrderNotification(completeOrders);
    executeCompleteOrderNotification(
      completePrevious,
      completeLatest,
      (data) => {
        setPosDeliveryStatusComplete(
          data,
          this.props.loginReducer.loginInfo.idx,
          this.props.loginReducer.loginInfo.token
        );
      }
    );
    setPreviousNotifyCompleteOrders(completeLatest);
  };

  updateBmOrder = async () => {
    const self = this;
    const orders = await this.getOrderListAsync(true);
    const previous = getPreviousNotifyOrders();
    const latest = generateOrderNotification(orders);

    executeOrderNotification(previous, latest, (data, cancel) => {
      setPosDeliveryStatus(
        data,
        cancel,
        self.props.loginReducer.loginInfo.idx,
        self.props.loginReducer.loginInfo.token
      );
    });

    setPreviousNotifyOrders(latest);
  };

  getDepositAsync = async (hideLoading) => {
    try {
      const res = await httpGet(httpUrl.riderNCash, [], {}, hideLoading);
      if (res.result !== 'SUCCESS') {
        return -1;
      }
      return res.data.ncash;
    } catch (e) {
      return -1;
    }
  };
  getDeliveryDataAsync = async (hideLoading) => {
    try {
      const userInfo = reactLocalStorage.getObject(Const.appName + '#userinfo');
      const branchIdx = userInfo?.branchIdx;

      if (isNaN(branchIdx)) {
        return { result: 'EXCEPTION' };
      }

      const res = await httpGet(httpUrl.branch, [branchIdx], {}, hideLoading);
      if (res.result === 'SUCCESS') {
        return res;
      } else {
        return { result: 'EXCEPTION' };
      }
    } catch (e) {
      console.warn('getDeliveryDataAsync raised exception. e: ' + e);
      return { result: 'EXCEPTION' };
    }
  };

  getOrderListAsync = async (hideLoading) => {
    try {
      const res = await httpGet(
        httpUrl.orderProcList,
        [
          50,
          1,
          [
            orderStatusCode.order,
            orderStatusCode.assign,
            orderStatusCode.pickup,
          ],
        ],
        {},
        hideLoading
      );
      if (res.result !== 'SUCCESS') {
        return null;
      }
      return res.data.orders;
    } catch (e) {
      return null;
    }
  };
  getPaymentListAsync = async (hideLoading) => {
    try {
      const res = await httpGet(httpUrl.orderPaymentList, [], {}, hideLoading);
      if (res.result !== 'SUCCESS') {
        return null;
      }
      return res.data;
    } catch (e) {
      return null;
    }
  };
  getOrderCompleteListAsync = async (hideLoading) => {
    try {
      const res = await httpGet(
        httpUrl.orderCompleteListRecent,
        [],
        {},
        hideLoading
      );
      if (res.result !== 'SUCCESS') {
        return null;
      }
      return res.data.orders;
    } catch (e) {
      return null;
    }
  };

  getBasicPickupTimesAsync = async () => {
    const res = await httpGet(httpUrl.getBasicPickupTime, [], {});
    if (res.result === 'SUCCESS') {
      reactLocalStorage.setObject(Const.appName + '#basicPickupTime', res.data);
      return res.data;
      // this.setState({ frBasicPickupTime: res.data });
      // this.props.updateBasicPickupTime(res.data);
    } else {
      return null;
    }
  };

  getAddrBranchesAsync = async () => {
    const prevAddrBranch = await reactLocalStorage.getObject(
      Const.appName + '#addrBranch'
    );

    try {
      const res = await httpGet(httpUrl.getAddrDelivery, [1, 1000], {});
      if (res.result === 'SUCCESS') {
        // 전체 데이터 보존
        reactLocalStorage.setObject(
          Const.appName + '#totalAddrBranch',
          res.data.addrDeliveries
        );

        const addrBranchFilter = res.data.addrDeliveries.filter(
          (addrDelivery) =>
            this.findAddrBranch(
              addrDelivery,
              this.props.loginReducer.loginInfo.addr3
            )
        );

        if (addrBranchFilter.length > 0) {
          reactLocalStorage.setObject(
            Const.appName + '#addrBranch',
            addrBranchFilter[0]
          );

          this.setState({ addrBranch: addrBranchFilter[0] });

          if (
            prevAddrBranch.quickMenu !== addrBranchFilter[0].quickMenu &&
            !addrBranchFilter[0].quickMenu
          ) {
            Modal.info({
              title: '배송불가 알림',
              content: '지역 배달 불가 상태입니다.',
              ...modalStyle,
            });

          }
        } else {
          this.setState({ addrBranch: { quickMenu: true } });
        }
      }
    } catch (e) {
      throw e;
    }
  };

  getAddrDeliveryAsync = async () => {
    try {
      const res = await httpGet(httpUrl.getAddrDelivery, [1, 10000], {});
      if (res.result === 'SUCCESS') {
        reactLocalStorage.setObject(
          Const.appName + '#addrDelivery',
          res.data.addrDeliveries
        );
      }
    } catch (e) {}
  };

  getSurchargeAsync = async () => {
    try {
      const res = await httpGet(
        httpUrl.getAppliedSurchargeList,
        [1, 10000],
        {}
      );
      if (res.result === 'SUCCESS') {
        const prevSurcharge = reactLocalStorage.getObject(
          Const.appName + '#surcharge'
        );

        const newSurcharge = res.data.deliveryPriceExtras;
        reactLocalStorage.setObject(Const.appName + '#surcharge', newSurcharge);
        const compareRes = this.compareSurchargePrev(
          prevSurcharge,
          newSurcharge
        );

        let surchargeSum = 0;
        newSurcharge.forEach((item) => (surchargeSum += item.extraPrice));
        this.setState({
          surchargeSum,
        });

        if (compareRes !== null) {
          Modal.info({
            title: '할증적용 안내',
            content: `${compareRes.map((item, idx) => {
              if (idx === 0) return item.name;
              else return ', ' + item.name;
            })} 할증이 추가 적용 되었습니다`,
            ...modalStyle,
          });

          global.speak('할증이 추가되었습니다.');
        }
      }
    } catch (e) {}
  };

  filterSurcharge = (list) => {
    let filterList = [...list];

    // 할증 그룹 정보 필터링
    filterList = filterList.filter(
      (item) =>
        item.frSettingGroupIdx === null ||
        item.frSettingGroupIdx ===
          this.props.loginReducer.loginInfo.frSettingGroupIdx
    );

    // 할증 on 된 경우 필터링
    filterList = filterList.filter((item) => item.enabled);

    // 할증 기간 필터링
    filterList = filterList.filter((item) =>
      checkBetweenTime(item.startDate, item.endDate)
    );

    // 상시 할증 필터링
    filterList = filterList.filter((item) => {
      const start = new Date(item.startDate);
      const end = new Date(item.endDate);

      const startYear = start.getFullYear();
      const endYear = end.getFullYear();
      // 상시 할증 확인
      if (startYear === 1999 && endYear === 2999) {
        const now = new Date();
        const nowH = now.getHours();
        const nowM = now.getMinutes();

        const startH = start.getHours();
        const endH = end.getHours();
        const startM = start.getMinutes();
        const endM = end.getMinutes();

        if (startH < nowH && nowH < endH) {
          return true;
        } else if (startH === nowH && startM < nowM) {
          return true;
        } else if (endH === nowH && nowM < endM) {
          return true;
        }
        return false;
      }
      return true;
    });
    // 노출여부 on 된 경우 필터링
    filterList = filterList.filter((item) => item.visible);

    return filterList;
  };

  compareSurchargePrev = (prevList, newList) => {
    if (!prevList || prevList === {} || !newList || newList === {}) return null;
    let added = [];
    newList.forEach((item) => {
      if (prevList.findIndex((prevItem) => prevItem.idx === item.idx) === -1)
        added.push(item);
    });
    return added.length === 0 ? null : added;
  };

  findAddrBranch = (addrDelivery, frAddr) => {
    if (!frAddr || frAddr == '') return false;
    return frAddr.indexOf(addrDelivery.eupMyeonDong) > 0;
    // const frAddrSplit = frAddr.split(" ");
    // for (let i = 0; i < frAddrSplit.length; i++) {
    //   if (frAddrSplit[i] === addrBranch.eupMyeonDong) {
    //     return true;
    //   }
    // }
    // return false;
  };

  closePosOrderModal = () => {
    this.setState({ posOrderModalOpen: false });
  };

  updateTime = () => {
    let current = new Date();
    let pickup = new Date();
    pickup.setMinutes(pickup.getMinutes() + 10);

    this.setState({
      currentTimeString: formatHM(current),
      pickupTimeString: formatHM(pickup),
    });
  };

  frUpdateTime = () => {
    const res = httpPost(httpUrl.updateTime, [], {}).catch((e) => {});

    return res;
  };

  callRider = () => {
    this.setState({ posOrderModalOpen: false });
    this.props.history.push({
      pathname: '/main',
      state: {
        ...this.state.posOrder,
      },
    });
  };

  handleBridgeAction = async (req) => {

    this.props.addPosOrder({
      waiting: false,
      custPhone: req.order.phone,
      destAddr1: req.order.destAddr1,
      destAddr2: req.order.destAddr2,
      orderPrice: req.order.price,
      orderDate: req.order.date,
      custMessage: req.order.memo,
    });

    this.setState({ posOrderModalOpen: true });
  };

  messageAlert = () => {
    // <audio>
    //   <source src="../../public/3.wav" />
    // </audio>
    const useEtcVoiceGuidance = getUseNotifyOrderEtc();

    if (useEtcVoiceGuidance) {
      let audio = new Audio('3.wav');
      audio.volume = this.props.posReducer.volume;
      audio.crossOrigin = 'anonymous';
      audio.play();
    }
  };

  initializeVolumeSetting = async () => {
    const prevVolume = await reactLocalStorage.getObject(
      Const.appName + '#volume'
    );
    if (typeof prevVolume === 'number') {
      this.props.setVolumeSetting(prevVolume);
    }
  };
  initializeMultiPosSetting = async () => {
    const multiPosSetting = reactLocalStorage.getObject(
      Const.appName + '#multiPosSetting'
    );

    if (
      multiPosSetting !== null &&
      multiPosSetting !== undefined &&
      typeof multiPosSetting !== 'object'
    ) {
      this.props.setMultiPosSetting(multiPosSetting);
    }
  };

  getOrderAwaitList = async () => {

    //TODO ojoomi d1 정식서비스 후 주석해제
    const res = await httpPost(httpUrl.getOrderAwaitList, [], {}, true);
    /*const cloudflareOrderAwaitRes = await getOrderAwaitByBranchIdxFrIdxAtCloudFlareWorker(); // cloudflare worker d1에서 대기주문 가져오기.*/

    let list = [];
    for (let i=0;i<res.data.orderAwaitList.length;i++) {
      let stringOrder = res.data.orderAwaitList[i];
      list.push(JSON.parse(stringOrder));
    }
    // cloudflare worker d1에서 대기주문 가져오기.
    let cloudflareOrderAwaitList = [];
    /*if (cloudflareOrderAwaitRes.status === 200 && Array.isArray(cloudflareOrderAwaitRes?.data?.orderAwaitList)
        && cloudflareOrderAwaitRes?.data?.orderAwaitList?.length > 0) {
      cloudflareOrderAwaitList = cloudflareOrderAwaitRes?.data?.orderAwaitList;
    }*/

    // console.log('getOrderAwaitList, order await length:' + list.length);
    if (list.length === 0 && cloudflareOrderAwaitList.length === 0 && this.props.posReducer.waitingOrders.length === 0) // 대기주문이 하나도 없는 경우 return, posReducer.waitingOrders.length === 0 조건을 안 넣으면 이미 접수된 주문이 대기주문으로 남아있는 현상 종종 발생함.
      return;

    /*for (let i=0;i<cloudflareOrderAwaitList.length;i++) {
      let orderAwait = cloudflareOrderAwaitList[i];
      list.push({...orderAwait});
    }*/

    //진행중인것이 있는지 체크
    let activeOrders = null;
    if (getUseAutoConfirmOrder()) {
      //solmea - 여기서 이걸 꼭 호출해야할까. 다른 좋은 방법이 없을까...
      //일단 최소한으로 호출하자
      activeOrders = await this.getOrderListAsync(true);
    }

    for (let i = 0; i < list.length; i++) {
      let orderAwait = list[i];

      let autoConfirm = false;
      if (getUseAutoConfirmOrder() && !isExistsPendingOrder(orderAwait)) {

        const existsOrder = activeOrders != null ? activeOrders.find((order) => isSameOrder(orderAwait, order)) : false;

        if (existsOrder) {
          //지워버리기
          await deleteOrderAwaitAsync(orderAwait); // TODO ojoomi: redis에 있는 대기주문이 모두 없어지면 이 라인 코드 삭제
          /*await deleteOrderAwaitAtCloudFlareWorker(orderAwait);*/
          // addPendingOrder(orderAwait);
        } else {
          await this.autoConfirmOrder(orderAwait);
          activeOrders.push(orderAwait) //대기주문에서 동일건 있으면 activeorder에 넣어서 제외되도록 처리
          autoConfirm = true;
        }
      }

      if (!autoConfirm) {
        this.updateReducerForWaitingOrder(orderAwait);
      }
    }

    //사라진오더 체크
    for (let i = 0; i < this.props.posReducer.waitingOrders.length; i++) {
      const wo = this.props.posReducer.waitingOrders[i];

      if (
        wo.id &&
        list.findIndex((orderAwait) => orderAwait.id === wo.id) < 0
      ) {
        this.props.removeWaitingOrderByOrderAwaitId(wo.id);
      }
    }
  };

  autoConfirmOrder = async (orderAwait) => {

    //TODO - solmea : procList.js에서 필요한 코드를 가져옴. 일단 이걸로 진행하고, 구조가 더 파악되면 중복코드 제거하도록 리팩토링하자.
    const distRes = await calcShippingDataAsync(orderAwait.destAddr1, orderAwait.destAddr3);
    const bmOrderCode = orderAwait.orderCode ? orderAwait.orderCode : null;
    const deliveryData = reactLocalStorage.getObject(Const.appName + '#deliverydata');
    const delayPickupTime = deliveryData ? deliveryData.delayPickupTime || 0 : 0;
    const basicPickupTime = reactLocalStorage.getObject(Const.appName + '#basicPickupTime') || 0;
    const arriveReqTime = Math.max(delayPickupTime + basicPickupTime, orderAwait.arriveReqTime || getAutoConfirmPickupTime());

    let orderCreate = {
      ...orderAwait,
      orderDate: '',
      latitude: distRes.lat,
      longitude: distRes.lng,
      bmOrderCode,
      deliveryPrice: distRes.deliveryBasicPrice + distRes.deliveryAddPrice,
      ncashPayEnabled: true,
      itemPrepared: orderAwait.itemPrepared || 'false',
      packAmount: orderAwait.packAmount || 1,
      arriveReqTime,
      orderStatus: 1,
      waitingStatus: 0,
      waiting: true,
      frIdx: 0,
      riderName: null,
      riderPhone: null,
      autoCreate: true,
    };

    let createResult = await createOrderAsync(orderCreate, true);
    if (createResult === 'SUCCESS') {
      console.log('order created, id:' + orderCreate.id);
      this.postJobForAutoCreateOrder(orderCreate);
    }
    else if(createResult === 'DUPLICATED_ORDER') {
      //중복된 주문이면 대기주문 삭제
      console.log('Duplicated order. remove await order:' + orderCreate.id);
      this.props.removeWaitingOrderByOrderAwaitId(orderCreate.id);
      await deleteOrderAwaitAsync(orderCreate); // TODO ojoomi: redis에 있는 대기주문이 모두 없어지면 이 라인 코드 삭제
      /*await deleteOrderAwaitAtCloudFlareWorker(orderCreate);*/
    } else {
      //자동 주문 보류 리스트에 정보 저장
      addPendingOrder(orderAwait);
      this.updateReducerForWaitingOrder(orderAwait);
    }
  };

  updateReducerForWaitingOrder = (orderAwait) => {
    if (this.props.posReducer.waitingOrders.find((order) => orderAwait.id === order.id)) {
      this.props.updateWaitingOrder(orderAwait);
    } else {
      this.props.addWaitingOrder(orderAwait);
    }
  };

  postJobForAutoCreateOrder = async (orderCreate) => {
    this.props.removeWaitingOrderByOrderAwaitId(orderCreate.id);
    //procList.js에서 주문성공시 코드 그대로 가져옴
    await deleteOrderAwaitAsync(orderCreate); // TODO ojoomi: redis에 있는 대기주문이 모두 없어지면 이 라인 코드 삭제
    /*await deleteOrderAwaitAtCloudFlareWorker(orderCreate);*/

    if (orderCreate.custPhone.length < 8) return;

    let localStorageOrderInfos = [];
    let cloudFlareOrderInfo = [];
    let orderInfos = reactLocalStorage.getObject(Const.appName + '#orderInfo');
    if (Array.isArray(orderInfos)) {
      localStorageOrderInfos = orderInfos;
    }
    const prevOrderInfo = localStorageOrderInfos.find(
        (x) => x.id === orderCreate.custPhone
    );
    // 하나 찾아서 지우지 말고 전체 리스트 필터링
    const filteredList = localStorageOrderInfos.filter(
        (x) => x.id !== orderCreate.custPhone
    );
    // localStorageOrderInfos = filteredList;
    reactLocalStorage.setObject(Const.appName + '#orderInfo', filteredList);

    cloudFlareOrderInfo = await getOrderInfoListFromCloudFlareWorker();
    const orderInfo = cloudFlareOrderInfo.find(
        (x) => x.metadata && x.metadata.id === orderCreate.custPhone
    );
    let orderCount = 1;
    if (orderInfo) {
      const orderDetail = await getOrderInfoDetailFromCloudFlareWorker(orderCreate.custPhone);
      orderCount =
          orderDetail && orderDetail.orderCount ? orderDetail.orderCount + 1 : 1;
    }
    if (prevOrderInfo) {
      orderCount =
          prevOrderInfo && prevOrderInfo.orderCount
              ? prevOrderInfo.orderCount + 1
              : 1;
    }

    try {
      const res = await createOrderInfoAtCloudFlareWorker({
        id: orderCreate.custPhone,
        custPhone: orderCreate.custPhone,
        destAddr1: orderCreate.destAddr1,
        destAddr2: orderCreate.destAddr2,
        destAddr3: orderCreate.destAddr3,
        custMessage: orderCreate.custMessage,
        orderCount,
      });
      if (!orderInfo && res.data.result === 'success') {
        // const list = await getOrderInfoListFromCloudFlareWorker();
        // cloudFlareOrderInfo = list;
      }
    } catch (e) {}
  };

  addOrderInfosForTesting = () => {
    const generateRandomCode = (n) => {
      let str = '';
      for (let i = 0; i < n; i++) {
        str += Math.floor(Math.random() * 10);
      }
      return str;
    };

    for (let i = 0; i < 10000; i++) {
      const custPhone = '010' + generateRandomCode(8);
      const orderInfo = {
        id: custPhone,
        custPhone,
        destAddr1: '경기도 김포시 풍무로96번길 100 풍무자이',
        destAddr2: '',
        destAddr3: '경기도 김포시 풍무동 766 풍무자이',
        orderCount: 1,
      };
      this.props.addOrderInfo(orderInfo);
    }
  };

  storeLocalStorages = async (object, hostName, frSettingIdx, setOrNot) => {
    try {
      const frIdx = reactLocalStorage.getObject(
        Const.appName + '#userinfo'
      ).idx;
      const res = await httpPost(httpUrl.storeLocalStorageToServer, [], {
        frSettingIdx: frSettingIdx !== null ? frSettingIdx : null,
        frIdx: frIdx,
        psBaeminSetting:
          object['psBaeminSetting'] === undefined
            ? null
            : object['psBaeminSetting'] === 'true'
            ? 1
            : 0,
        multiPosSetting:
          object['multiPosSetting'] === undefined
            ? null
            : object['multiPosSetting'] === 'true'
            ? 1
            : 0,
        keyboardSetting:
          object['keyboardSetting'] === undefined
            ? null
            : object['keyboardSetting'] === 'true'
            ? 1
            : 0,
        notifyOrderNew:
          object['notifyOrderNew'] === undefined
            ? null
            : object['notifyOrderNew'] === 'true'
            ? 1
            : 0,
        notifyOrderAssign:
          object['notifyOrderAssign'] === undefined
            ? null
            : object['notifyOrderAssign'] === 'true'
            ? 1
            : 0,
        notifyOrderPickup:
          object['notifyOrderPickUp'] === undefined
            ? null
            : object['notifyOrderPickUp'] === 'true'
            ? 1
            : 0,
        notifyOrderComplete:
          object['notifyOrderComplete'] === undefined
            ? null
            : object['notifyOrderComplete'] === 'true'
            ? 1
            : 0,
        notifyOrderEtc:
          object['notifyOrderEtc'] === undefined
            ? null
            : object['notifyOrderEtc'] === 'true'
            ? 1
            : 0,
        notifyChat:
          object['notifyChat'] === undefined
            ? null
            : object['notifyChat'] === 'true'
            ? 1
            : 0,
        notifyPosOrder:
          object['notifyPosOrder'] === undefined
            ? null
            : object['notifyPosOrder'] === 'true'
            ? 1
            : 0,
        notifyPosOrderPort:
          object['notifyPosOrderPort'] === undefined
            ? null
            : parseInt(JSON.parse(object['notifyPosOrderPort'])),
        posOrderAllowDuplicates:
          object['posOrderAllowDuplicates'] === undefined
            ? null
            : object['posOrderAllowDuplicates'] === 'true'
            ? 1
            : 0,
        notifyCid:
          object['notifyCid'] === undefined
            ? null
            : object['notifyCid'] === 'true'
            ? 1
            : 0,
        notifyCidPort:
          object['notifyCidPort'] === undefined
            ? null
            : parseInt(JSON.parse(object['notifyCidPort'])),
        notifyPosOrderRelationApp:
          object['notifyPosOrderRelationApp'] === undefined
            ? null
            : JSON.parse(object['notifyPosOrderRelationApp'])['enable'] === true
            ? 1
            : 0,
        notifyPosOrderRelationAppPort:
          object['notifyPosOrderRelationAppPort'] === undefined
            ? null
            : JSON.parse(object['notifyPosOrderRelationAppPort'])['port'] * 1,
        posOrderRelationAppAllowDuplicates:
          object['posOrderRelationAppAllowDuplicates'] === undefined
            ? null
            : JSON.parse(object['posOrderRelationAppAllowDuplicates'])[
                'enable'
              ] === true
            ? 1
            : 0,
        refPickupTime:
          object['refPickupTime'] === undefined
            ? null
            : object['refPickupTime'] * 1,
        prevPickupTime:
          object['prevPickupTime'] === undefined
            ? null
            : object['prevPickupTime'] * 1,
        volume: object['volume'] === undefined ? null : object['volume'] * 1,
        cardCharge:
          object['cardCharge'] === undefined
            ? null
            : JSON.parse(object['cardCharge']),
        selectSimpleDong:
          object['selectSimpleDong'] === undefined
            ? null
            : object['selectSimpleDong'],
        addrBookmark:
          object['addrBookmark'] === undefined ? null : object['addrBookmark'],
        orderInfo:
          object['orderInfo'] === undefined ? null : object['orderInfo'],
        hostName: hostName,
      });
      if (res.result === 'SUCCESS' && res.data === 'SUCCESS') {
        reactLocalStorage.setObject('prevLocalStorage', object);
        if (setOrNot === true) this.getLocalStorage(frIdx);
      }
    } catch (error) {
      console.error('storeLocalStorages error: ', error);
    }
  };

  getLocalStorage = async (frIdx) => {
    try {
      const res = await httpGet(httpUrl.getLocalStorageFromServer, [frIdx], {});
      if (res.result === 'SUCCESS') {
        /**일단 테이블에 데이터가 2개면 set해주지 않는다. */
        if (res.data.frLocalStorages.length > 1) return;
        else if (res.data.frLocalStorages.length === 1) {
          const frLocalStorage = res.data.frLocalStorages[0];
          if (frLocalStorage['psBaeminSetting'] !== null)
            reactLocalStorage.setObject(
              Const.appName + '#psBaeminSetting',
              frLocalStorage['psBaeminSetting'] === 0 ? false : true
            );
          if (frLocalStorage['multiPosSetting'] !== null)
            reactLocalStorage.setObject(
              Const.appName + '#multiPosSetting',
              frLocalStorage['multiPosSetting'] === 0 ? false : true
            );
          if (frLocalStorage['keyboardSetting'] !== null)
            reactLocalStorage.setObject(
              Const.appName + '#keyboardSetting',
              frLocalStorage['keyboardSetting'] === 0 ? false : true
            );
          if (frLocalStorage['notifyOrderNew'] !== null)
            reactLocalStorage.setObject(
              Const.appName + '#notifyOrderNew',
              frLocalStorage['notifyOrderNew'] === 0 ? false : true
            );
          if (frLocalStorage['notifyOrderAssign'] !== null)
            reactLocalStorage.setObject(
              Const.appName + '#notifyOrderAssign',
              frLocalStorage['notifyOrderAssign'] === 0 ? false : true
            );
          if (frLocalStorage['notifyOrderPickup'] !== null)
            reactLocalStorage.setObject(
              Const.appName + '#notifyOrderPickup',
              frLocalStorage['notifyOrderPickup'] === 0 ? false : true
            );
          if (frLocalStorage['notifyOrderComplete'] !== null)
            reactLocalStorage.setObject(
              Const.appName + '#notifyOrderComplete',
              frLocalStorage['notifyOrderComplete'] === 0 ? false : true
            );
          if (frLocalStorage['notifyOrderEtc'] !== null)
            reactLocalStorage.setObject(
              Const.appName + '#notifyOrderEtc',
              frLocalStorage['notifyOrderEtc'] === 0 ? false : true
            );
          if (frLocalStorage['notifyChat'] !== null)
            reactLocalStorage.setObject(
              Const.appName + '#notifyChat',
              frLocalStorage['notifyChat'] === 0 ? false : true
            );
          if (frLocalStorage['notifyPosOrder'] !== null)
            reactLocalStorage.setObject(
              Const.appName + '#notifyPosOrder',
              frLocalStorage['notifyPosOrder'] === 0 ? false : true
            );
          if (frLocalStorage['notifyPosOrderPort'] !== null)
            reactLocalStorage.setObject(
              Const.appName + '#notifyPosOrderPort',
              frLocalStorage['notifyPosOrderPort']
            );
          if (frLocalStorage['posOrderAllowDuplicates'] !== null)
            reactLocalStorage.setObject(
              Const.appName + '#posOrderAllowDuplicates',
              frLocalStorage['posOrderAllowDuplicates'] === 0 ? false : true
            );
          if (frLocalStorage['notifyCid'] !== null)
            reactLocalStorage.setObject(
              Const.appName + '#notifyCid',
              frLocalStorage['notifyCid'] === 0 ? false : true
            );
          if (frLocalStorage['notifyCidPort'] !== null)
            reactLocalStorage.setObject(
              Const.appName + '#notifyCidPort',
              frLocalStorage['notifyCidPort']
            );

          if (frLocalStorage['notifyPosOrderRelationApp'] !== null)
            reactLocalStorage.setObject(
              Const.appName + '#notifyPosOrderRelationApp',
              {
                enable:
                  frLocalStorage['notifyPosOrderRelationApp'] === 0
                    ? false
                    : true,
              }
            );
          if (frLocalStorage['notifyPosOrderRelationAppPort'] !== null)
            reactLocalStorage.setObject(
              Const.appName + '#notifyPosOrderRelationAppPort',
              { port: frLocalStorage['notifyPosOrderRelationAppPort'] }
            );
          if (frLocalStorage['posOrderRelationAppAllowDuplicates'] !== null)
            reactLocalStorage.setObject(
              Const.appName + '#posOrderRelationAppAllowDuplicates',
              {
                enable:
                  frLocalStorage['posOrderRelationAppAllowDuplicates'] === 0
                    ? false
                    : true,
              }
            );

          if (frLocalStorage['refPickupTime'] !== null)
            reactLocalStorage.setObject(
              Const.appName + '#refPickupTime',
              frLocalStorage['refPickupTime']
            );
          if (frLocalStorage['prevPickupTime'] !== null)
            reactLocalStorage.setObject(
              Const.appName + '#prevPickupTime',
              frLocalStorage['prevPickupTime']
            );
          if (frLocalStorage['volume'] !== null)
            reactLocalStorage.setObject(
              Const.appName + '#volume',
              frLocalStorage['volume']
            );

          if (frLocalStorage['cardCharge'] !== null)
            reactLocalStorage.setObject(
              Const.appName + '#cardCharge',
              frLocalStorage['cardCharge']
            );
          if (frLocalStorage['selectSimpleDong'] !== null)
            reactLocalStorage.setObject(
              Const.appName + '#selectSimpleDong',
              JSON.parse(frLocalStorage['selectSimpleDong'])
            );
          if (frLocalStorage['addrBookmark'] !== null)
            reactLocalStorage.setObject(
              Const.appName + '#addrBookmark',
              JSON.parse(frLocalStorage['addrBookmark'])
            );
          if (frLocalStorage['orderInfo'] !== null) {
            const orderInfos = JSON.parse(frLocalStorage['orderInfo']);
            reactLocalStorage.setObject(
              Const.appName + '#orderInfo',
              orderInfos
            );
            /** 서버에서 가져온 ORDER_INFO를 redux에 저장  */
            orderInfos.forEach((orderInfo) => {
              this.props.addOrderInfo(orderInfo, true);
            });
          }
          if (
            frLocalStorage['hostName'] !== null &&
            frLocalStorage['hostName'] !== ''
          )
            reactLocalStorage.setObject(
              Const.appName + '#hostName',
              frLocalStorage['hostName']
            );
        }
      }
    } catch (error) {
      console.error('getLocalStorage error: ', error);
    }
  };

  franchiseLocalStorage = async () => {
    // 엽기떡볶이 행걸리는 이슈로 일단 임시 리턴 처리
    return;

    let unique_id = reactLocalStorage.getObject(Const.appName + '#hostName');
    if ((typeof unique_id !== 'string') || 0 === unique_id.length ) {
      unique_id = uuid();
      reactLocalStorage.setObject(Const.appName + '#hostName', unique_id);
    }
    const frIdx = reactLocalStorage.getObject(Const.appName + '#userinfo').idx;
    const hostName = unique_id;
    const object = {};
    //로그인 시 혹은 헤더에서 세팅해주는 로컬스토리지 key목록(이 array의 요소들은 서버에 저장하지 않아도 됨.)
    const array = [
      'userinfo',
      'auth',
      'calculateHour',
      'deposit',
      'posOrder',
      'addrDelivery',
      'basicPickupTime',
      'noticeForNew',
      'surcharge',
      'totalAddrBranch',
      'deliverydata',
      'deliveryStatShow',
      'branchTel',
      'orders',
      'completeorders',
      'addrBranch',
      'payments',
      'waitingOrder',
      'delayPickupSetting', // 어디서 셋팅되는지 모르겠으나 일단 제외..
      'hostName',
      'getJibunAddr',
    ];

    for (let i = 0; i < localStorage.length; i++) {
      let key = localStorage.key(i);
      if (
        key.includes(Const.appName) &&
        !array.includes(key.substring(Const.appName.length + 1))
      )
        object[key.substring(Const.appName.length + 1)] =
          localStorage.getItem(key);
    }

    /*
     object를 로컬스토리지에 "prevLocalStorage"로 저장 후 object와 비교해서 바뀐 게 있을 경우 서버에 저장
     최초로 reactLocalStorage.getObject("prevLocalStorage") 호출할경우 빈 객체 {}로 옴.
     localStorage.getItem()으로 가져오는 value들은 전부 string으로 취급돼서 파싱 필요.
     */
    const prevLocalStorageString = JSON.stringify(
      reactLocalStorage.getObject('prevLocalStorage')
    );
    const objectString = JSON.stringify(object);
    try {
      const res = await httpGet(httpUrl.getLocalStorageFromServer, [frIdx], {});
      const frLocalStorages = res.data.frLocalStorages;
      /** 신규 가맹점 */
      if (frLocalStorages.length === 0 && objectString.length > 2) {
        this.storeLocalStorages(object, hostName, null, false);
      } else if (
        /** 기존 가맹점 / prevLocal이 {}이면 length가 2 */
        frLocalStorages.length === 1 &&
        frLocalStorages[0].hostName === hostName &&
        prevLocalStorageString.length > 2 &&
        prevLocalStorageString !== objectString
      ) {
        const frSettingIdx = frLocalStorages[0].frSettingIdx;
        this.storeLocalStorages(object, hostName, frSettingIdx, true);
      } else if (
        /** 기존 가맹점(기기 2대) */
        frLocalStorages.length > 1 &&
        prevLocalStorageString !== objectString
      ) {
        const matchHostNameList = frLocalStorages.filter(
          (item) => item.hostName === hostName
        );
        const noHostNameList = frLocalStorages.filter(
          (item) => item.hostName === ''
        ); /** hostName이 없는 데이터 */
        /** hostName이 localStorage에 있는 hostName과 일치하는 데이터가 있으면 그 데이터만 변경하고
         * hostName이 없는 데이터가 있으면 없는 데이터를 변경 */
        const frSettingIdx =
          matchHostNameList.length > 0
            ? matchHostNameList[0].frSettingIdx
            : noHostNameList.length > 0
            ? noHostNameList[0].frSettingIdx
            : null;
        this.storeLocalStorages(object, hostName, frSettingIdx, false);
      } else if (
        /** 도메인 옮길 때*/
        frLocalStorages.length === 1 &&
        prevLocalStorageString.length === 2
      ) {
        this.getLocalStorage(frIdx);
        reactLocalStorage.setObject('prevLocalStorage', object);
      }
    } catch (e) {
      console.error('localStorage error: ', e);
    }
  };

  renderDelayTime() {
    if (
      !this.props.pickupTimeReducer.pickupTimeInfo.deliveryEnabled ||
      !this.state.addrBranch.quickMenu
    ) {
      return null;
    }
    const { basicPickupTime, delayPickupTime } =
      this.props.pickupTimeReducer.pickupTimeInfo;

    const totalDelayTime = basicPickupTime + delayPickupTime;

    if (isNaN(totalDelayTime)) {
      return '---분';
    } else if (totalDelayTime > 1000) {
      return '후' + (totalDelayTime % 1000) + '분';
    } else {
      return `${totalDelayTime}분 / ${moment()
        .add(totalDelayTime, 'm')
        .format('HH:mm')}`;
    }
  }

  getSkinPopupList = () => {
    /**2:가맹점로고스킨, 3:가맹점로고배경스킨, 4:가맹점배달현황스킨, 5:가맹점접수요청스킨, 6:가맹점예치금내역스킨,
   7:가맹점설정스킨, 8:가맹점로그아웃스킨, 9:가맹점배너배경스킨, 10: 가맹점팝업 */
    const categoryList = [2, 3, 4, 5, 6, 7, 8, 9, 10];
    const deleted = 0;
    const userInfo = reactLocalStorage.getObject(Const.appName + '#userinfo');
    const branchIdx = userInfo?.branchIdx;
    if (branchIdx !== null && branchIdx !== undefined) {
      httpGet(httpUrl.getSkinPopupList, [categoryList, deleted, branchIdx], {})
        .then((res) => {
          if (
            res.result === 'SUCCESS' &&
            typeof res.data === 'object' &&
            Array.isArray(res.data.list) &&
            res.data.list.length > 0
          ) {
            this.setState(
              {
                skinPopupList: res.data.list,
              }
            );
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  };

  closePopup = () => {
    this.setState({
      popupVisible: false,
    });
  };

  /*getFrIPInfo = async () => {
    try {
      const userInfo = reactLocalStorage.getObject(Const.appName + '#userinfo');
      const frIdx = userInfo?.idx;
      const frName = userInfo?.frName;
      const branchIdx = userInfo?.branchIdx;
      const branchName = userInfo?.branchName;
      const userId = userInfo?.id;
      const hostSplit = document.location.host.split(':');
      const url = document.location.protocol + '//' + hostSplit[0];
      const port = hostSplit[1] || 0;

      const res = await httpExec('PUT', 'https://nnlog.nyamnyampay.com/nnlog', {
        name: '가맹점 접속 주소',
        category: '가맹점 접속 주소',
        userIdx: frIdx,
        userId,
        branchIdx,
        branchName,
        frIdx,
        frName,
        url,
        port,
      });
    } catch (error) {
      console.error('getFrIPInfo error!!! ', error);
    }
  };*/

  render() {
    const columns = [
      {
        title: '번호',
        key: 'idx',
        dataIndex: 'idx',
        className: 'column-center',
      },
      {
        title: '제목',
        key: 'title',
        dataIndex: 'title',
        className: 'column-left',
      },
      {
        title: '등록일',
        key: 'createDate',
        dataIndex: 'createDate',
        className: 'column-center mobileoff',
      },
    ];

    const menuCode = {
      delivery: 0,
      main: 1,
      calculate: 2,
      setting: 3,
    };

    const menus = [
      { idx: menuCode.delivery, path: '/delivery' },
      { idx: menuCode.main, path: '/main' },
      { idx: menuCode.calculate, path: '/calculate' },
      { idx: menuCode.setting, path: '/setting' },
    ];
    const currentPage = menus.find(
      (x) => x.path === this.props.history.location.pathname.toLowerCase()
    );

    const settings = {
      className: 'center',
      infinite: true,
      centerPadding: '60px',
      swipeToSlide: true,
      afterChange: function (index) {
      },
    };

    const { isPosPolling } = this.state;
    const { isSubPosPolling } = this.state;
    const posenable = getUseNotifyPosOrder();
    const subposenable = getUseNotifyPosOrderRelationApp();

    /**2:가맹점로고스킨, 3:가맹점로고배경스킨, 4:가맹점배달현황스킨, 5:가맹점접수요청스킨, 6:가맹점예치금내역스킨,
   7:가맹점설정스킨, 8:가맹점로그아웃스킨, 9:가맹점배너배경스킨 */
    const { skinPopupList } = this.state;
    const logoImageList = skinPopupList.filter((item) => item.category === 2);
    const logoBackgroundList = skinPopupList.filter(
      (item) => item.category === 3
    );
    const deliveryImageList = skinPopupList.filter(
      (item) => item.category === 4
    );
    const mainImageList = skinPopupList.filter((item) => item.category === 5);
    const calculateImageList = skinPopupList.filter(
      (item) => item.category === 6
    );
    const settingImageList = skinPopupList.filter(
      (item) => item.category === 7
    );
    const logoutImageList = skinPopupList.filter((item) => item.category === 8);
    const bannerBackgroundList = skinPopupList.filter(
      (item) => item.category === 9
    );
    const frPopupList = skinPopupList.filter((item) => item.category === 10);

    const skinType = Const.skinType.toUpperCase();

    return (
      <div className={skinType === "GOGOIT" ? "gogoit-header" : "header"}>
        <div className="header-left mobileoff">
          <img
            style={
              logoBackgroundList.length > 0
                ? {
                    backgroundImage: `url(${imageUrl(
                      logoBackgroundList[0].uploadFileIdx
                    )})`,
                    display: 'inline',
                  }
                : { display: 'inline' }
            }
            src={
              logoImageList.length > 0
                ? imageUrl(logoImageList[0].uploadFileIdx)
                : image.headerLogo
            }
            className={
            skinType === "GOGOIT" ? 'gogoit-header-logo'
                :
              logoImageList.length > 0
                ? 'header-logo-with-image'
                : 'header-logo'
            }
            alt=""
          />
          <div
            className="header-body-left mobileoff"
            style={
              bannerBackgroundList.length > 0
                ? {
                    backgroundImage: `url(${imageUrl(
                      bannerBackgroundList[0].uploadFileIdx
                    )})`,
                  }
                : { backgroundImage: '' }
            }>
            <div>
              <div className="header-body-left-menu">
                <Link to="/delivery">
                  {currentPage.idx === menuCode.delivery ? (
                    <div>
                      <img
                        style={{ display: 'inline' }}
                        src={
                          deliveryImageList.length > 0
                            ? imageUrl(deliveryImageList[0].uploadFileIdx)
                            : image.deliveryOnIcon
                        }
                        className={
                          skinType === "GOGOIT" ? "gogoit-header-body-logo2" :
                          deliveryImageList.length > 0
                            ? 'header-body-logo2-with-image'
                            : 'header-body-logo2'
                        }
                        alt=""
                      />
                      <div className={skinType === "GOGOIT" ? "gogoit-header-body-left-menu-text-color" : "header-body-left-menu-text-color"}>
                        배달현황
                      </div>
                    </div>
                  ) : (
                    <div>
                      <img
                        style={{ display: 'inline' }}
                        src={
                          deliveryImageList.length > 0
                            ? imageUrl(deliveryImageList[0].uploadFileIdx)
                            : image.deliveryIcon
                        }
                        className={
                          skinType === "GOGOIT" ? "gogoit-header-body-logo2" :
                          deliveryImageList.length > 0
                            ? 'header-body-logo2-with-image'
                            : 'header-body-logo2'
                        }
                        alt=""
                      />
                      <div className="header-body-left-menu-text">배달현황</div>
                    </div>
                  )}
                </Link>
              </div>
              <div className="header-body-left-menu2">
                <Link to="/main">
                  {currentPage.idx === menuCode.main ? (
                    <div>
                      <img
                        style={{ display: 'inline' }}
                        src={
                          mainImageList.length > 0
                            ? imageUrl(mainImageList[0].uploadFileIdx)
                            : image.pickupOnIcon
                        }
                        className={
                          skinType === "GOGOIT" ? "gogoit-header-body-logo" :
                          mainImageList.length > 0
                            ? 'header-body-logo-with-image'
                            : 'header-body-logo'
                        }
                        alt=""
                      />
                      <div className={skinType === "GOGOIT" ? "gogoit-header-body-left-menu-text-color" : "header-body-left-menu-text-color"}>
                        접수요청
                      </div>
                    </div>
                  ) : (
                    <div>
                      <img
                        style={{ display: 'inline' }}
                        src={
                          mainImageList.length > 0
                            ? imageUrl(mainImageList[0].uploadFileIdx)
                            : image.pickupIcon
                        }
                        className={
                          skinType === "GOGOIT" ? "gogoit-header-body-logo" :
                          mainImageList.length > 0
                            ? 'header-body-logo-with-image'
                            : 'header-body-logo'
                        }
                        alt=""
                      />
                      <div className="header-body-left-menu-text">접수요청</div>
                    </div>
                  )}
                </Link>
              </div>
              <div className="header-body-left-menu3">
                <Link to="/calculate">
                  {currentPage.idx === menuCode.calculate ? (
                    <div>
                      <img
                        style={{ display: 'inline' }}
                        src={
                          calculateImageList.length > 0
                            ? imageUrl(calculateImageList[0].uploadFileIdx)
                            : image.paymentOnIcon
                        }
                        className={
                          skinType === "GOGOIT" ? "gogoit-header-body-logo3" :
                          calculateImageList.length > 0
                            ? 'header-body-logo3-with-image'
                            : 'header-body-logo3'
                        }
                        alt=""
                      />
                      <div className={skinType === "GOGOIT" ? "gogoit-header-body-left-menu-text-color" : "header-body-left-menu-text-color"}>
                        예치금내역
                      </div>
                    </div>
                  ) : (
                    <div>
                      <img
                        style={{ display: 'inline' }}
                        src={
                          calculateImageList.length > 0
                            ? imageUrl(calculateImageList[0].uploadFileIdx)
                            : image.paymentIcon
                        }
                        className={
                          skinType === "GOGOIT" ? "gogoit-header-body-logo3" :
                          calculateImageList.length > 0
                            ? 'header-body-logo3-with-image'
                            : 'header-body-logo3'
                        }
                        alt=""
                      />
                      <div className="header-body-left-menu-text">
                        예치금내역
                      </div>
                    </div>
                  )}
                </Link>
              </div>
            </div>
            <div>
              <div className="header-body-left-menu-pos-state">
                <div className={skinType === "GOGOIT" ? "gogoit-header-body-left-menu-pos-text" : "header-body-left-menu-pos-text"}>
                  POS
                  {isPosPolling && posenable ? (
                    <div className="pos-status pos-enabled" />
                  ) : (
                    <div className="pos-status pos-disabled" />
                  )}
                </div>
              </div>
            </div>
            <div>
              <div className="header-body-left-menu-pos-state">
                <div className={skinType === "GOGOIT" ? "gogoit-header-body-left-menu-pos-text" : "header-body-left-menu-pos-text"}>
                  SUB POS
                </div>
                {isSubPosPolling && subposenable ? (
                    <div className="pos-status pos-enabled" />
                  ) : (
                    <div className="pos-status pos-disabled" />
                  )}
              </div>
            </div>
            {/*{skinType === "NNBOX" &&*/}
            {/*    <div>*/}
            {/*      <div*/}
            {/*          className="header-body-left-menu-event-text"*/}
            {/*          onClick={() => {*/}
            {/*            localStorage.removeItem('EventCookieRenew2');*/}
            {/*            window.location.reload(true);*/}
            {/*          }}*/}
            {/*      >*/}
            {/*        룰렛이벤트 보기*/}
            {/*      </div>*/}
            {/*    </div>*/}
            {/*}*/}
            <div>
              <div className="header-body-left-menu-pos-state">
                {/*<div className="header-body-left-menu-pos-text">*/}
                {/*  Y연동*/}
                {/*</div>*/}
                <YWebSocket />
              </div>
            </div>
            <div>
              <div className="header-body-left-menu4">
                <Link to="/setting">
                  {currentPage.idx === menuCode.setting ? (
                    <div>
                      <img
                        style={{ display: 'inline' }}
                        src={
                          settingImageList.length > 0
                            ? imageUrl(settingImageList[0].uploadFileIdx)
                            : image.settingOnIcon
                        }
                        className={
                          skinType === "GOGOIT" ? "gogoit-header-body-logo4" :
                          settingImageList.length > 0
                            ? 'header-body-logo4-with-image'
                            : 'header-body-logo4'
                        }
                        alt=""
                      />
                      <div className={skinType === "GOGOIT" ? "gogoit-header-body-left-menu-text-color" : "header-body-left-menu-text-color"}>
                        설정
                      </div>
                    </div>
                  ) : (
                    <div>
                      <img
                        style={{ display: 'inline' }}
                        src={
                          settingImageList.length > 0
                            ? imageUrl(settingImageList[0].uploadFileIdx)
                            : image.settingIcon
                        }
                        className={
                          skinType === "GOGOIT" ? "gogoit-header-body-logo4" :
                          settingImageList.length > 0
                            ? 'header-body-logo4-with-image'
                            : 'header-body-logo4'
                        }
                        alt=""
                      />
                      <div className="header-body-left-menu-text">설정</div>
                    </div>
                  )}
                </Link>
              </div>
              <div
                className="header-body-left-menu5"
                onClick={() => {
                  this.logout();
                }}>
                <img
                  style={{ display: 'inline' }}
                  src={
                    logoutImageList.length > 0
                      ? imageUrl(logoutImageList[0].uploadFileIdx)
                      : image.logoutIcon
                  }
                  className={
                    logoutImageList.length > 0
                      ? 'header-body-logo5-with-image'
                      : 'header-body-logo5'
                  }
                  alt=""
                />
                <div className="header-body-left-menu-text">로그아웃</div>
              </div>
            </div>
          </div>
        </div>
        {/* 모바일버전 헤더*/}
        <div className="header-top-menu mobile">
          <div
            className="ham-menu"
            onClick={() => {
              this.setState({ openSlideMenu: 1 });
            }}>
            <div />
            <div />
            <div />
          </div>

          <div className="header-logo">
            <Link to="/delivery">
              <img
                style={{ display: 'inline' }}
                src={image.headerLogoM02}
                alt="logo"
              />
            </Link>
          </div>
        </div>
        {this.state.openSlideMenu === 1 && (
          <div
            className="slide-menu-overaly mobile"
            onClick={() => {
              this.setState({ openSlideMenu: 0 });
            }}>
            <div className="slide-menu">
              <div>
                <div>
                  {' '}
                  <img
                    style={{ display: 'inline' }}
                    src={image.resetIcon}
                    alt="close"
                  />
                </div>
                <div>
                  {' '}
                  <img
                    style={{ display: 'inline' }}
                    src={image.shopIcon}
                    alt="shop"
                  />{' '}
                  {this.props.loginReducer.loginInfo.frName}{' '}
                </div>
                <div>
                  {' '}
                  {comma(this.props.depositReducer.deposit)} <p>원</p>{' '}
                  <p
                    onClick={() => {
                      this.setState({ chargeModalOpen: true });
                    }}>
                    충전
                  </p>
                </div>
                <div>
                  <ul>
                    <li>
                      {getFrStatusString(
                        this.props.loginReducer.loginInfo.frStatus
                      )}
                    </li>
                    <li
                      onClick={() => {
                        this.setState(
                          {
                            noticeVisible: true,
                            pagination: {
                              pageSize: 10,
                              current: 1,
                            },
                          },
                          () => this.getNoticeList()
                        );
                      }}>
                      공지사항
                    </li>
                    <li
                      onClick={() => {
                        this.setState({ chatModalOpen: true });
                      }}>
                      <img
                        style={{ display: 'inline' }}
                        src={
                          !this.props.websock.isConnected
                            ? image.chatOnIcon
                            : image.chatOffIcon
                        }
                        alt=""
                      />
                    </li>
                  </ul>
                </div>

                <div>
                  [가상계좌] {''}
                  {this.props.loginReducer.loginInfo.vaccountBank &&
                    this.props.loginReducer.loginInfo.vaccountBank.split(
                      ','
                    )[0]}
                  <br />
                  {this.props.loginReducer.loginInfo.vaccountNumber} /
                  {this.props.loginReducer.loginInfo.vaccountDepositor}
                </div>
              </div>

              <div>
                <Link to="/delivery">
                  <div>
                    {' '}
                    <img
                      style={{ display: 'inline' }}
                      src={image.headerDeliveryIcon}
                      alt="delivety"
                    />{' '}
                    배달현황{' '}
                  </div>
                </Link>
                <Link to="/main">
                  <div>
                    {' '}
                    <img
                      style={{ display: 'inline' }}
                      src={image.mainIcon}
                      alt="main"
                    />{' '}
                    접수요청{' '}
                  </div>
                </Link>
                <Link to="/calculate">
                  <div>
                    {' '}
                    <img
                      style={{ display: 'inline' }}
                      src={image.calculateIcon}
                      alt="calculate"
                    />{' '}
                    예치금내역{' '}
                  </div>
                </Link>
                <Link to="/setting">
                  <div>
                    {' '}
                    <img
                      style={{ display: 'inline' }}
                      src={image.headerSettingIcon}
                      alt="setting"
                    />{' '}
                    설정{' '}
                  </div>
                </Link>
                <div
                  onClick={() => {
                    this.logout();
                  }}>
                  {' '}
                  <img
                    style={{ display: 'inline' }}
                    src={image.headerLogoutIcon}
                    alt="logout"
                  />{' '}
                  로그아웃{' '}
                </div>
              </div>
            </div>
          </div>
        )}{' '}
        {/* 모바일버전 끝 */}
        <div className="header-main mobileoff">
          <div className="header-menu-contact">
            <div>긴급연락처: {this.state.branchTel}</div>
            <div className="header-menu-surcharge">
              할증요금 : {`${comma(this.state.surchargeSum)}`}원
            </div>
            <div className="header-top-box8-text">
              가상계좌:
              {this.props.loginReducer.loginInfo.vaccountBank &&
                this.props.loginReducer.loginInfo.vaccountBank.split(
                  ','
                )[0]}{' '}
              {this.props.loginReducer.loginInfo.vaccountNumber}{' '}
              {this.props.loginReducer.loginInfo.vaccountDepositor}
            </div>
          </div>

          <div className="header-menu">
            <div className="header-menu-titleWrap">
              <div className="header-top-text">
                {/*{this.props.loginReducer.loginInfo.frName}*/}
                {truncate(this.props.loginReducer.loginInfo.frName,15)}
              </div>

              <div className="header-top-box">
                <div className="header-top-box-block">
                  {comma(this.props.depositReducer.deposit)}
                  <span className="header-top-box-text2">원</span>
                </div>
              </div>

              <div className={skinType === "GOGOIT" ? "gogoit-header-menu-status" : "header-menu-status"}>{this.renderDelayTime()}</div>
            </div>

            <div className="header-top-box7-box desk">
              {(Const.serverIp === 'nnstage.nnbox.net' ||
                Const.serverIp === '127.0.0.1') && (
                <Button onClick={() => this.addOrderInfosForTesting()}>
                  테스트용 버튼
                </Button>
              )}
              <div
                className={skinType === "GOGOIT" ? "gogoit-header-top-box6" : "header-top-box6"}
                onClick={() => {
                  this.setState({ chatModalOpen: true });
                }}>
                <img
                  style={{ display: 'inline' }}
                  src={
                    !this.props.websock.isConnected ? image.chatOnIcon : image.chatOffIcon
                  }
                  alt=""
                />
                {/* <img src={require('../img/header/chat-off.png').default} alt="채팅꺼짐" />*/}
              </div>

              <div className="header-top-box7">
                <div
                  className="header-top-box7-text"
                  onClick={() => {
                    this.setState({ controlChatModalOpen: true });
                  }}>
                  관제문의
                </div>
              </div>

              <div className="header-top-box7">
                <div
                  className="header-top-box7-text"
                  onClick={() => {
                    this.setState({ chargeModalOpen: true });
                  }}>
                  예치금충전
                </div>
              </div>

              <div className="header-top-box7">
                <div
                  className={skinType === "GOGOIT" ? "gogoit-header-top-box7-text2" : "header-top-box7-text2"}
                  onClick={() => {
                    this.setState(
                      {
                        noticeVisible: true,
                        pagination: {
                          pageSize: 10,
                          current: 1,
                        },
                      },
                      () => this.getNoticeList()
                    );
                  }}>
                  공지사항
                </div>
              </div>
              {this.state.cidList.length > 0 && (
                <div
                  className="header-top-box7-text2"
                  style={{
                    background: 'red',
                    width: 60,
                    marginLeft: 10,
                    color: '#fff',
                    fontWeight: 500,
                  }}
                  onClick={() => {
                    this.setState({ cidPopup: true });
                  }}>
                  CID
                </div>
              )}
            </div>

            {/* 반응형 */}
            <div className="header-top-menu-box pos">
              <div
                className={skinType === "GOGOIT" ? "gogoit-header-top-box6" : "header-top-box6"}
                onClick={() => {
                  this.setState({ chatModalOpen: true });
                }}>
                <img
                  style={{ display: 'inline' }}
                  src={
                    !this.props.websock.isConnected ? image.chatOnIcon : image.chatOffIcon
                  }
                  alt=""
                />
              </div>

              <div className="header-top-box7">
                <div
                  className="header-top-box7-text"
                  onClick={() => {
                    this.setState({ chargeModalOpen: true });
                  }}>
                  예치금충전
                </div>
              </div>
              <div className="header-top-box7">
                <div
                  className="header-top-box7-text"
                  onClick={() => {
                    this.setState({ controlChatModalOpen: true });
                  }}>
                  관제문의
                </div>
              </div>
              <div className="header-top-box7">
                <div
                  className={skinType === "GOGOIT" ? "gogoit-header-top-box7-text2" :"header-top-box7-text2"}
                  onClick={() => {
                    this.setState(
                      {
                        noticeVisible: true,
                        pagination: {
                          pageSize: 10,
                          current: 1,
                        },
                      },
                      () => this.getNoticeList()
                    );
                  }}>
                  공지사항
                </div>
              </div>
              {this.state.cidList.length > 0 && (
                <div
                  className={skinType === "GOGOIT" ? "gogoit-header-top-box6" : "header-top-box6"}
                  onClick={() => {
                    this.setState({ cidPopup: true });
                  }}>
                  CID
                </div>
              )}
              <br />
            </div>
            {/* 반응형 끝 */}
          </div>

          {this.state.mainNotice && (
            <div
              className="header-top-box5-block"
              onClick={() => {
                this.setState({
                  noticeVisible: true,
                  selectedNotice: this.state.mainNotice.idx,
                });
              }}>
              <div className="track">
                <p>
                  {
                    this.state.eventRankList.map(
                        rank => <p style={{color:'red'}}>
                          <b>{'돌려 DREAM EVENT:'}</b>
                          {`${rank.rank}등\"${rank.name}\"${comma(rank.prize)}원 당첨되었습니다.`}
                        </p>
                    )
                  }
                  <p>
                    <b>[{this.state.mainNotice.title}]</b>{' '}
                    {this.state.mainNotice.content}{' '}
                  </p>
                </p>

              </div>
            </div>
          )}
        </div>
        <PosOrderModal
          isOpen={this.state.posOrderModalOpen}
          close={this.closePosOrderModal}
          callRider={this.callRider}
          order={this.state.posOrder}
        />
        {this.state.noticeVisible && this.state.selectedNotice === 0 && (
          <div
            className="modal-container "
            onClick={(e) => {
              if (e.target !== e.currentTarget) return;
              this.setState({ noticeVisible: false, selectedNotice: 0 });
            }}>
            <div style={{ position: 'relative' }} className="notice-container">
              <div className={skinType === "GOGOIT" ? "gogoit-notice-title mobileoff": "notice-title mobileoff"}>
                <div
                  className="notice-close"
                  onClick={(e) => {
                    this.setState({ noticeVisible: false, selectedNotice: 0 });
                  }}>
                  <img style={{ display: 'inline' }} src={image.closeIcon} alt="" />
                </div>
                <div className={skinType === "GOGOIT" ? "gogoit-notice-table mobileoff": "notice-table mobileoff"}>
                  <Table
                    onChange={(pagination) =>
                      this.setState({ noticePagination: pagination }, () =>
                        this.getNoticeList()
                      )
                    }
                    pagination={this.state.noticePagination}
                    rowKey={(record) => record.idx}
                    dataSource={this.state.noticeList}
                    columns={columns}
                    onRow={(record, rowIndex) => {
                      return {
                        onClick: (event) => {
                          this.setState({ selectedNotice: record.idx });
                        }, // click row
                      };
                    }}
                  />
                </div>
              </div>
              <div className="mobile">
                <div className={skinType === "GOGOIT" ? "gogoit-notice-table mobile" : "notice-table mobile"}>
                  <Table
                    rowKey={(record) => record.idx}
                    dataSource={this.state.noticeList}
                    columns={columns}
                    onRow={(record, rowIndex) => {
                      return {
                        onClick: (event) => {
                          this.setState({ selectedNotice: record.idx });
                        }, // click row
                      };
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        {this.state.noticeVisible && this.state.selectedNotice !== 0 && (
          <div
            className="modal-container"
            onClick={(e) => {
              if (e.target !== e.currentTarget) return;
              this.setState({ noticeVisible: false, selectedNotice: 0 });
            }}>
            <div className="notice-container mobileoff">
              <div style={{ position: 'relative' }} className={skinType === "GOGOIT" ? "gogoit-notice-title":"notice-title"}>
                <div className="notice-title-main">
                  {
                    this.state.noticeList.find(
                      (x) => x.idx === this.state.selectedNotice
                    ).title
                  }
                </div>
                <div className="notice-title-date">
                  · 등록일:{' '}
                  {
                    this.state.noticeList.find(
                      (x) => x.idx === this.state.selectedNotice
                    ).createDate
                  }
                </div>
                <div
                  className="notice-close"
                  onClick={(e) => {
                    this.setState({ noticeVisible: false, selectedNotice: 0 });
                  }}>
                  <img style={{ display: 'inline' }} src={image.closeIcon} alt="" />
                </div>
              </div>
              <div className="notice-detail">
                <div>
                  {this.state.noticeList
                    .find((x) => x.idx === this.state.selectedNotice)
                    .content.split('\n')
                    .map((value, index) => {
                      return (
                        <div key={index}>
                          {value}
                          <br />
                        </div>
                      );
                    })}
                </div>
              </div>
              <div className="notice-bottom">
                <div className="notice-bottom-left">
                  <div
                    className="button-circle-gray"
                    onClick={() => {
                      let idx = this.state.noticeList.findIndex(
                        (x) => x.idx === this.state.selectedNotice
                      );
                      if (idx > 0) idx--;
                      this.setState({
                        selectedNotice: this.state.noticeList[idx].idx,
                      });
                    }}>
                    <span className="mobileoff">이전글</span>
                  </div>
                  <div
                    className="button-circle-gray"
                    onClick={() => {
                      let idx = this.state.noticeList.findIndex(
                        (x) => x.idx === this.state.selectedNotice
                      );
                      if (idx < this.state.noticeList.length - 1) idx++;
                      this.setState({
                        selectedNotice: this.state.noticeList[idx].idx,
                      });
                    }}>
                    <span className="mobileoff">다음글</span>
                  </div>
                </div>
                <div className="notice-bottom-right">
                  <div
                    className="button-circle-black"
                    onClick={() => {
                      this.setState({ selectedNotice: 0 });
                    }}>
                    <span className="mobileoff">목록보기</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="notice-container mobile">
              <div style={{ position: 'relative' }} className={skinType === "GOGOIT" ? "gogoit-notice-title":"notice-title"}>
                <div className="notice-title-main">
                  {
                    this.state.noticeList.find(
                      (x) => x.idx === this.state.selectedNotice
                    ).title
                  }
                </div>
                <div className="notice-title-date">
                  등록일:{' '}
                  {
                    this.state.noticeList.find(
                      (x) => x.idx === this.state.selectedNotice
                    ).createDate
                  }
                </div>
              </div>
              <div className="notice-detail">
                <div>
                  {this.state.noticeList
                    .find((x) => x.idx === this.state.selectedNotice)
                    .content.split('\n')
                    .map((value, index) => {
                      return (
                        <div key={index}>
                          {value}
                          <br />
                        </div>
                      );
                    })}
                </div>
              </div>
              <div className="notice-bottom">
                <div
                  onClick={() => {
                    let idx = this.state.noticeList.findIndex(
                      (x) => x.idx === this.state.selectedNotice
                    );
                    if (idx > 0) idx--;
                    this.setState({
                      selectedNotice: this.state.noticeList[idx].idx,
                    });
                  }}>
                  <span>이전글</span>
                </div>
                <div
                  onClick={() => {
                    this.setState({ selectedNotice: 0 });
                  }}>
                  <span>목록보기</span>
                </div>
                <div
                  onClick={() => {
                    let idx = this.state.noticeList.findIndex(
                      (x) => x.idx === this.state.selectedNotice
                    );
                    if (idx < this.state.noticeList.length - 1) idx++;
                    this.setState({
                      selectedNotice: this.state.noticeList[idx].idx,
                    });
                  }}>
                  <span>다음글</span>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* {
          this.state.noticeVisible && this.state.selectedNotice !== 0 &&
          this.messageAlert()
        } */}
        {this.props.branchReducer.branchInfo.dwServiceType === 2 &&
          this.state.chargeModalOpen && (
            <PaystoryChargeModal
              close={() => this.setState({ chargeModalOpen: false })}
              loginInfo={this.props.loginReducer.loginInfo}
              renewDeposit={this.renewDeposit}
            />
          )}
        {this.props.branchReducer.branchInfo.dwServiceType === 1 && (
          <ChargeModal
            isOpen={this.state.chargeModalOpen}
            close={() => this.setState({ chargeModalOpen: false })}
            loginInfo={this.props.loginReducer.loginInfo}
            renewDeposit={this.renewDeposit}
          />
        )}
        <ControlChatModal
          isOpen={this.state.controlChatModalOpen}
          close={() => this.setState({ controlChatModalOpen: false })}
        />
        {this.state.chatModalOpen && (
          <Chatting
            isOpen={this.state.chatModalOpen}
            close={() => this.setState({ chatModalOpen: false, chatOn: false })}
          />
        )}
        {this.state.eFormsignModalOpen && (
          (this.state.isMobile ?
            <Modal
              visible={this.state.eFormsignModalOpen}
              title={titleofConsent}
              okText="확인"
              footer={[
                <Button
                  key="ok"
                  onClick={() => {
                    this.setState({ eFormsignModalOpen: false });
                  }}>
                  확인
                </Button>,
              ]}
              destroyOnClose={true}>
              <div>
                {titleofConsent}가 필요합니다. POS 가맹 프로그램으로 접속하셔서
                개인정보 제공 동의서를 작성 해주세요.
              </div>
            </Modal>
          :
            <EFormsignModal
              close={() => this.setState({ eFormsignModalOpen: false })}
              resulteFormsignInfo={this.resulteFormsignInfo}
              frIdx={this.props.loginReducer.loginInfo.idx}
              frName={this.props.loginReducer.loginInfo.frName}
              businessNumber={this.props.loginReducer.loginInfo.businessNumber}
              ownerName={this.props.loginReducer.loginInfo.ownerName}
              branchIdx={this.props.loginReducer.loginInfo.branchIdx}
              branchName={this.props.loginReducer.loginInfo.branchName}
            />
          )
        )}
        {this.state.popupVisible && frPopupList.length > 0 && (
          <Popup
            visible={this.state.popupVisible}
            closable={true}
            maskClosable={true}
            onClose={this.closePopup}
            settings={settings}
            frPopup={frPopupList[0]}
          />
        )}
        <Modal
          visible={this.state.cidPopup}
          title="CID 연동"
          close={() => this.setState({ cidPopup: false })}
          footer={[
            <Button
              key="ok"
              onClick={() => {
                this.setState({ cidPopup: false });
              }}>
              닫기
            </Button>,
          ]}
          destroyOnClose={true}>
          <div>
            {this.state.cidList.map((row) => {
              return (
                <div style={{ fontSize: '16px', padding: '5px' }}>
                  <div
                    style={{
                      display: 'inline-block',
                      width: '150px',
                      fontWeight: 'bold',
                    }}>
                    {row.cidNum}
                  </div>
                  <div style={{ display: 'inline-block', width: '150px' }}>
                    {row.createDate}
                  </div>
                  <div style={{ display: 'inline-block' }}>
                    <Button
                      style={{ marginRight: '10px' }}
                      onClick={() => {
                        const removeIdx = this.state.cidList.findIndex(
                          (x) => x.idx == row.idx
                        );
                        if (
                          removeIdx >= 0 &&
                          this.state.cidList.length > removeIdx
                        ) {
                          this.state.cidList.splice(removeIdx, 1);
                          this.setState({ cidList: this.state.cidList });
                        }

                        this.setState({ cidPopup: false });

                        this.props.history.push({
                          pathname: '/main',
                          state: { cidNum: row.cidNum },
                        });
                      }}>
                      접수
                    </Button>
                    <Button
                      onClick={() => {
                        const removeIdx = this.state.cidList.findIndex(
                          (x) => x.idx == row.idx
                        );
                        if (
                          removeIdx >= 0 &&
                          this.state.cidList.length > removeIdx
                        ) {
                          this.state.cidList.splice(removeIdx, 1);
                          this.setState({ cidList: this.state.cidList });
                        }
                      }}>
                      삭제
                    </Button>
                  </div>
                </div>
              );
            })}
          </div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    depositReducer,
    orderReducer,
    loginReducer,
    posReducer,
    websock,
    pickupTimeReducer,
    branchReducer,
  } = state;
  return {
    depositReducer,
    orderReducer,
    loginReducer,
    posReducer,
    websock,
    pickupTimeReducer,
    branchReducer,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      login,
      logout,
      setConsentDocId,
      setDeposit,
      addPosOrder,
      removePosOrder,
      removePosOrderByOrderCode,
      removePosOrderAll,
      addWaitingOrder,
      removeWaitingOrderByOrderCode,
      removeWaitingOrderAll,
      addOrderInfo,
      removeOrderInfoAll,
      setVolumeSetting,
      setMultiPosSetting,
      removeOldPosOrder,
      removeOldWaitingOrder,
      updateWaitingOrder,
      removeWaitingOrder,
      removeWaitingOrderByOrderAwaitId,
      updateBasicPickupTime,
      updateBranchDelayTime,
      updateBasicPickupTimeAndDelay,
      updatePosOrder,
      removePosOrderByOrderAwaitId,
      setBranchInfo,
    },
    dispatch
  );
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
